import request from '@/utils/request' 
import axios from 'axios'
//"http://prj03.xnfz.cmet.ustc.edu.cn/server/"
//http://localhost:8079/api/
export function getServerUrl() { return "http://prj03.xnfz.cmet.ustc.edu.cn/server/"; }
export function getTeachMaterials(type) {
    return axios.post(getServerUrl() + "services/files.asmx/getFiles", {
        type: type
    }, { headers: { 'Content-Type': 'application/json; charset=utf-8' } });
}
export function testValues() {
    return request({
        url: '/api/values/1',
        method: 'get'
    })
}
  

var socreUrl = "http://xnfz.cmet.ustc.edu.cn/virexp/three/dimensional/savescore";

//测试校方服务器状态
export function scoreUrlState(fun) {
    $.ajax({
        url: socreUrl,
        type: "post",
        contentType: "application/x-www-form-urlencoded",
        dataType: "json", //指定服务器返回的数据类型
        success: function (data) {
            fun(true);
        },
        error: function (err) {
            console.log(err);
            fun(false);
        }
    });
}

//提交测试结果
export function postCore(user, callback) {
    scoreUrlState((state) => {
        if (!state) {
            callback(false);
            return;
        }
        var standard = {};
        standard.numberId = user.num;
        standard.eId = user.eid;
        standard.eid = user.eid;
        standard.expScore = 100;
        $.ajax({
            type: "post",
            url: socreUrl,
            data: {
                'param': JSON.stringify(standard)
            },
            success: function (result) {
                var result = result.status;
                if (result == "200") {
                    callback(true);
                    return;
                } else {
                    callback(false);
                }
            },
            error: function (error) {
                console.log(error);
                callback(false);
            }
        });
    })
}


export function addLoginLog(num, ip, address) {
    return axios.post(getServerUrl() + "services/users.asmx/addUserLog", {
        pid: 3,
        num: num,
        ip: ip,
        address: address
    });
}

export function getLoginLog(sDate, eDate, isInner, txt, pageIndex, pageSize) {
    return axios.post(getServerUrl() + "services/users.asmx/getUserLog", {
        pid: 3,
        sDate: sDate,
        eDate: eDate,
        isInner: isInner,
        txt: txt,
        pageIndex: pageIndex,
        pageSize: pageSize
    });
}